<template>
  <div class="contranter">
    <div id="main">
      <Topbar :tab_index="tab_index" :had_login="had_login"></Topbar>
      <div class="main-s">
        <img class="com-soon" src="../assets/coming.png" />
      </div>
    </div>
  </div>
</template>

<script>
import api from "../api/api";
import ops from "../leo.wang.util/operator.string";
import Topbar from "../components/Topbar.vue";
import pub from "../common/pub.js";
import Swiper from "swiper";
import $ from "jquery";
export default {
  name: "Dashboard",
  components: {
    Topbar: Topbar,
  },
  data() {
    return {
      title: "AXOR室内设计奖",
      tab_index: 3,
      had_login: false,
    };
  },
  methods: {
    naviToDetail(item) {
      // this.$router.push()
    },
  },
  created() {
    //window.document.title = this.title;
    let that = this;
  },
  mounted() {
    let that = this;
    let phone_number = localStorage.getItem("mobile");
    if (phone_number) {
      this.had_login = true;
      api
        .getMyInfo({
          user_phone: ops.encode(phone_number),
        })
        .then((res) => {
          that.u_info = res.data.data.info;
        });
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
body {
}
.com-soon {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/pages/Rank.vue